export default __webpack_public_path__ + "static/media/ic_falkland_islands.1f8fc093.svg";